import React from 'react';
import { connect } from 'react-redux';
import { Table, Container, Row, Col, Input } from 'reactstrap';
import i18n from "../../../i18next";
import Pagination from 'react-js-pagination';

import { loadOrderSearch } from '../../../actions/restaurants/customerInsight/CustomerInsightAction';
import { getPriceWithCurrencySymbol } from '../../../utils/CommonUtils';
import { DEFAULT_PAGE_SIZE, DEFAULT_PAGING_RANGE } from "../../../utils/Constants";
import CustomerInsightSearchOptions from './CustomerInsightSearchOptions';
import DeliverySVG from "../../common/svgs/DeliverySVG"
import PickUpSVG from "../../common/svgs/PickUpSVG";
import CurbsideSVG from "../../common/svgs/CurbsideSVG";
import InStoreSvg from "../../common/svgs/InStoreSVG";
import CashSVG from '../../common/svgs/CashSVG';
import CardsSVG from '../../common/svgs/CardsSVG';
import WebSVG from '../../common/svgs/WebSVG';
import MobileIconSVG from '../../common/svgs/MobileIconSVG';
import AppAndroidSVG from '../../common/svgs/AppAndroidSVG';
import AppAppleSVG from '../../common/svgs/AppAppleSVG';

class OrderSearch extends React.Component {

    state = {
        fromDate: '',
        toDate: '',
        page: 0,
        amount: '',
        orderId: '',
        address: '',
        orderTypeId: '',
        paymentTypeId: '',
        sourceTypeId: '',
        orderStatus: ''
    }

    componentDidMount() {
        const { restaurantId, customerId } = this.props;
        this.props.loadOrderSearch(restaurantId, customerId, this.state.page, this.state.fromDate, this.state.toDate,
            this.state.address, this.state.amount, this.state.orderTypeId, this.state.paymentTypeId,
            this.state.sourceTypeId, this.state.orderStatus, this.state.orderId);
    }

    takeSearchOptionState = searchOptionState => {
        const { restaurantId, customerId } = this.props;
        this.setState({
            fromDate: searchOptionState.fromDate,
            toDate: searchOptionState.toDate,
            page: 0
        }, () => this.props.loadOrderSearch(restaurantId, customerId, this.state.page, this.state.fromDate, this.state.toDate,
            this.state.address, this.state.amount, this.state.orderTypeId, this.state.paymentTypeId,
            this.state.sourceTypeId, this.state.orderStatus, this.state.orderId));
    }

    handlePageChange = pageNumber => {
        const { restaurantId, customerId } = this.props;
        this.setState({
            page: (pageNumber - 1)
        }, () => this.props.loadOrderSearch(restaurantId, customerId, this.state.page, this.state.fromDate, this.state.toDate,
            this.state.address, this.state.amount, this.state.orderTypeId, this.state.paymentTypeId,
            this.state.sourceTypeId, this.state.orderStatus, this.state.orderId));
    }

    renderOrderTable = () => {
        return (
            <Table responsive bordered hover style={{ marginTop: '25px' }}>
                <thead>
                    {this.renderTableHeaders()}
                </thead>
                <tbody>
                    {this.renderTableContent()}
                </tbody>
            </Table>
        );
    }

    renderTableHeaders = () => {

        const { tableHeaders, textCenter, textRight } = styles;

        return (
            <tr>
                <th style={{ ...tableHeaders }}>{i18n.t('screens:customerInsightScreen.orderId')}</th>
                <th style={{ ...tableHeaders, ...textCenter }}>{i18n.t('screens:customerInsightScreen.placedTime')}</th>
                <th style={{ ...tableHeaders, ...textCenter }}>{i18n.t('screens:customerInsightScreen.wantedTime')}</th>
                <th className="col-1" style={{ ...tableHeaders, ...textCenter }}>{i18n.t('screens:customerInsightScreen.orderType')}</th>
                <th className="col-1" style={{ ...tableHeaders, ...textCenter }}>{i18n.t('screens:customerInsightScreen.paymentType')}</th>
                <th className="col-1" style={{ ...tableHeaders, ...textCenter }}>{i18n.t('screens:customerInsightScreen.sourceType')}</th>
                <th style={{ ...tableHeaders, ...textRight }}>{i18n.t('screens:customerInsightScreen.totalAmount')}</th>
                <th className="col-3" style={{ ...tableHeaders }}>{i18n.t('screens:customerInsightScreen.address')}</th>
                <th style={{ ...tableHeaders, ...textCenter }}>{i18n.t('screens:customerInsightScreen.status')}</th>
                <th style={{ ...tableHeaders, ...textCenter }}>{i18n.t(`screens:customerInsightScreen.giftCardTotal`)}</th>
            </tr>
        );
    }

    renderTableContent = () => {
        return this.props.customerInsightOrderSearch.content.map(item => {
            return this.renderSingleItem(item);
        })
    }

    renderSingleItem = item => {

        const { tableDetail, firstRow, textCenter, textRight } = styles;
        const currency = this.props.restaurant.currency;
        
        return (
            <tr>
                <td style={{ ...tableDetail }}>{item.orderId}</td>
                <td style={{ ...tableDetail, ...textCenter }}>{item.placedTime}</td>
                <td style={{ ...tableDetail, ...textCenter }}>{item.wantedTime}</td>
                <td style={{ ...tableDetail, ...textCenter }}>{this.renderOrderSVGIcon(item.orderTypeId)}</td>
                <td style={{ ...tableDetail, ...textCenter }}>{this.renderPaymentSVGIcon(item.paymentTypeId)}</td>
                <td style={{ ...tableDetail, ...textCenter }}>{item.orderSource ? this.renderSourceSVGIcon(item.orderSource) : "-"}</td>
                <td style={{ ...tableDetail, ...textRight }}>{getPriceWithCurrencySymbol(item.priceTotal, currency)}</td>
                <td className="col-3" style={{ ...tableDetail }}>{item.orderAddress}</td>
                <td style={{ ...tableDetail, ...textCenter, fontWeight: 'normal' }}>{this.renderOrderStatus(item.status)}</td>
                <td style={{ ...tableDetail, ...textCenter }}>{getPriceWithCurrencySymbol(item.giftCardTotal, currency)}</td>
                {/* <td style={{ ...tableDetail }}>{item.rejectReason ? item.rejectReason : "-"}</td> */}
            </tr>
        );
    }

    renderOrderSVGIcon = id => {
        switch (id) {
            case 1: return <DeliverySVG width={22} height={22} fill={'#0288D1'} />;
            case 2: return <PickUpSVG width={22} height={22} fill={'#0288D1'} />
            case 4: return <CurbsideSVG width={22} height={22} fill={'#0288D1'} />
            case 5: return <InStoreSvg width={22} height={22} fill={'#0288D1'} />
            default: return "-"
        }
    }

    renderPaymentSVGIcon = id => {
        switch (id) {
            case 1: return <CardsSVG width={22} height={22} fill={'#0288D1'} />
            case 2: return <CashSVG width={22} height={22} fill={'#0288D1'} />
            default: return "-"
        }
    }

    renderSourceSVGIcon = type => {
        switch (type) {
            case "WEB": return <WebSVG width={20} height={20} fill={'#0288D1'} />
            case "WEB_ANDROID": return <MobileIconSVG width={22} height={22} fill={'#0288D1'} />
            case "WEB_IOS": return <MobileIconSVG width={22} height={22} fill={'#0288D1'} />
            case "APP_ANDROID": return <AppAndroidSVG width={22} height={22} fill={'#0288D1'} />
            case "APP_IOS": return <AppAppleSVG width={22} height={22} fill={'#0288D1'} />
            default: return "-"
        }
    }

    renderOrderStatus = type => {
        switch (type) {
            case "ACCEPTED": return <span style={{ color: 'rgb(117,170,100)' }}>{i18n.t('screens:customerInsightScreen.accepted')}</span>
            case "REJECTED": return <span style={{ color: 'rgb(193,35,48)' }}>{i18n.t('screens:customerInsightScreen.rejected')}</span>
            case "PARTIALLY_REFUNDED": return <span style={{ color: 'rgb(255,161,89)' }}>{i18n.t('screens:customerInsightScreen.partiallyRefunded')}</span>
            case "REFUNDED": return <span style={{ color: 'rgb(117,170,100)' }}>{i18n.t('screens:customerInsightScreen.refunded')}</span>
            case "CANCELED": return <span style={{ color: 'rgb(193,35,48)' }}>{i18n.t('screens:customerInsightScreen.canceled')}</span>
            case "PENDING": return <span>{i18n.t('screens:customerInsightScreen.pending')}</span>
            case "PENDING_IN_PROCESS": return <span>{i18n.t('screens:customerInsightScreen.pendingInProcess')}</span>
            case "PENDING_FUTURE_ORDER": return <span>{i18n.t('screens:customerInsightScreen.pendingFutureOrder')}</span>
            default: return "-";
        }
    }

    renderAdditionalSearchOptions = () => {

        return (
            <Container fluid>
                <Row style={{ marginBottom: '15px' }}>
                    {this.renderOrderIdInput()}
                    {this.renderAmountInput()}
                    {this.renderAddressInput()}
                </Row>
                <Row>
                    {this.renderOrderTypeDropdown()}
                    {this.renderPaymentTypeDropdown()}
                    {this.renderSourceTypeDropdown()}
                    {this.renderOrderStatusDropdown()}
                </Row>
            </Container>
        );
    }

    renderOrderTypeDropdown = () => {
        return (
            <Col sm={3} style={{ paddingLeft: 0 }} >
                <Input
                    type="select"
                    name="orderTypeId"
                    id="orderTypeId"
                    placeholder={i18n.t('screens:customerInsightScreen.selectOrderType')}
                    value={this.state.orderTypeId}
                    onChange={(e) => this.setState({ orderTypeId: e.target.value })}>
                    <option value=''>{i18n.t('screens:customerInsightScreen.selectOrderType')}</option>
                    <option value='1'>{i18n.t('screens:customerInsightScreen.Delivery')}</option>
                    <option value='2'>{i18n.t('screens:customerInsightScreen.Collection')}</option>
                    <option value='4'>{i18n.t('screens:customerInsightScreen.Curbside')}</option>
                    <option value='5'>{i18n.t(`screens:restaurantsMainContainer.instore`)}</option>
                </Input>
            </ Col>
        );
    }

    renderPaymentTypeDropdown = () => {
        return (
            <Col sm={3} style={{ paddingLeft: 0 }} >
                <Input
                    type="select"
                    name="paymentTypeId"
                    id="paymentTypeId"
                    placeholder={i18n.t('screens:customerInsightScreen.selectPaymentType')}
                    value={this.state.paymentTypeId}
                    onChange={(e) => this.setState({ paymentTypeId: e.target.value })}>
                    <option value=''>{i18n.t('screens:customerInsightScreen.selectPaymentType')}</option>
                    <option value='1'>{i18n.t('screens:customerInsightScreen.creditCard')}</option>
                    <option value='2'>{i18n.t('screens:customerInsightScreen.cash')}</option>

                </Input>
            </ Col>
        );
    }

    renderSourceTypeDropdown = () => {
        return (
            <Col sm={3} style={{ paddingLeft: 0 }} >
                <Input
                    type="select"
                    name="sourceTypeId"
                    id="sourceTypeId"
                    placeholder={i18n.t('screens:customerInsightScreen.selectSourceType')}
                    value={this.state.sourceTypeId}
                    onChange={(e) => this.setState({ sourceTypeId: e.target.value })}>
                    <option value=''>{i18n.t('screens:customerInsightScreen.selectSourceType')}</option>
                    <option value='1'>Web</option>
                    <option value='2'>Web Android</option>
                    <option value='3'>Web IOS</option>
                    <option value='4'>App Android</option>
                    <option value='5'>App IOS</option>

                </Input>
            </ Col>
        );
    }

    renderOrderStatusDropdown = () => {
        return (
            <Col sm={3} style={{ paddingLeft: 0 }} >
                <Input
                    type="select"
                    name="sourceTypeId"
                    id="sourceTypeId"
                    placeholder={i18n.t('screens:customerInsightScreen.selectSourceType')}
                    value={this.state.orderStatus}
                    onChange={(e) => this.setState({ orderStatus: e.target.value })}>
                    <option value=''>{i18n.t('screens:customerInsightScreen.status')}</option>
                    <option value='ACCEPTED'>{i18n.t('screens:customerInsightScreen.accepted')}</option>
                    <option value='REJECTED'>{i18n.t('screens:customerInsightScreen.rejected')}</option>
                    <option value='PARTIALLY_REFUNDED'>{i18n.t('screens:customerInsightScreen.partiallyRefunded')}</option>
                    <option value='REFUNDED'>{i18n.t('screens:customerInsightScreen.refunded')}</option>
                    <option value='CANCELED'>{i18n.t('screens:customerInsightScreen.canceled')}</option>
                    <option value='PENDING'>{i18n.t('screens:customerInsightScreen.pending')}</option>
                    <option value='PENDING_IN_PROCESS'>{i18n.t('screens:customerInsightScreen.pendingInProcess')}</option>
                    <option value='PENDING_FUTURE_ORDER'>{i18n.t('screens:customerInsightScreen.pendingFutureOrder')}</option>
                </Input>
            </ Col>
        );
    }

    renderOrderIdInput = () => {
        return (
            <Col sm={3} style={{ paddingLeft: 0 }} >
                <Input
                    type="text"
                    name="orderId"
                    id="orderId"
                    placeholder={i18n.t('screens:customerInsightScreen.orderId')}
                    onChange={(e) => this.setState({ orderId: e.target.value })}
                    value={this.state.orderId}
                />
            </ Col>
        );
    }

    renderAmountInput = () => {
        return (
            <Col sm={3} style={{ paddingLeft: 0 }} >
                <Input
                    type="text"
                    name="amount"
                    id="amount"
                    placeholder={i18n.t('screens:customerInsightScreen.amount')}
                    onChange={(e) => this.setState({ amount: e.target.value })}
                    value={this.state.amount}
                />
            </ Col>
        );
    }

    renderAddressInput = () => {
        return (
            <Col sm={6} style={{ paddingLeft: 0 }} >
                <Input
                    type="text"
                    name="amount"
                    id="amount"
                    placeholder={i18n.t('screens:customerInsightScreen.address')}
                    onChange={(e) => this.setState({ address: e.target.value })}
                    value={this.state.address}
                />
            </ Col>
        );
    }

    renderPagination() {
        const { flexEnd } = styles;

        return (
            <Container>
                <Row>
                    <Col style={flexEnd}>
                        <Pagination
                            activePage={this.props.customerInsightOrderSearch.number + 1}
                            itemsCountPerPage={DEFAULT_PAGE_SIZE}
                            totalItemsCount={this.props.customerInsightOrderSearch.totalElements}
                            pageRangeDisplayed={DEFAULT_PAGING_RANGE}
                            itemClass='page-item'
                            linkClass='page-link'
                            onChange={this.handlePageChange}
                        />
                    </Col>
                </Row>
            </Container>
        );
    }

    render() {
        return (
            <React.Fragment>
                <CustomerInsightSearchOptions type="OrderSearch" takeSearchOptionState={this.takeSearchOptionState} />
                {this.renderAdditionalSearchOptions()}
                {this.renderOrderTable()}
                {this.renderPagination()}
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        customerInsightOrderSearch: state.customerInsightOrderSearch,
        restaurant: state.restaurant
    }
};

export default connect(mapStateToProps, { loadOrderSearch })(OrderSearch);

const styles = {
    tableHeaders: {
        padding: '10px',
        fontSize: '16px',
        fontWeight: 'bold',
    },
    tableDetail: {
        padding: '10px 5px',
        fontSize: '14px',   //previously it was 14px not bolded
        fontWeight: 'bold',
    },
    firstRow: {
        //whiteSpace: 'nowrap'
        paddingRight: '0'
    },
    textCenter: {
        textAlign: 'center',
        padding: '10px 5px'
    },
    textRight: {
        textAlign: 'right',
        paddingLeft: '0'
    },
    flexEnd: {
        marginTop: '15px',
        display: 'flex',
        justifyContent: 'flex-end',
        paddingRight: 0
    }
}


// WEBPACK FOOTER //
// ./src/components/restaurants/customerInsightScreen/OrderSearch.js